import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import './CampaignPickerPage.css'

function CampaignPickerPage() {
  const navigate = useNavigate()
  const { isAdmin, authEpoch } = useAuth()
  const [campaigns, setCampaigns] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  // authEpoch: see the identical comment in components/tabs/ItemsTab.jsx.
  useEffect(() => {
    let cancelled = false
    fetch('/api/campaigns')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('Failed to load campaigns'))))
      .then((data) => {
        if (cancelled) return
        const list = Array.isArray(data) ? data : []
        setCampaigns(list)
        setLoading(false)
        // One campaign: go straight in, replacing history so Back doesn't bounce.
        if (list.length === 1) {
          navigate(`/c/${list[0].slug}/campaign`, { replace: true })
        }
      })
      .catch((err) => {
        if (cancelled) return
        setError(err.message)
        setLoading(false)
      })
    return () => { cancelled = true }
  }, [navigate, authEpoch])

  if (loading) {
    return <div className="picker-loading"><div className="picker-mark">🧭</div><p>Loading…</p></div>
  }

  return (
    <div className="picker-page">
      <header className="picker-header">
        <div className="picker-mark">🧭</div>
        <h1>Start your Quest</h1>
        <p className="picker-subtitle">Choose a campaign</p>
      </header>

      {error && <p className="picker-error">{error}</p>}

      {!error && campaigns.length === 0 && (
        <p className="picker-empty">
          You're not a member of any campaign yet. Ask a DM to add you.
        </p>
      )}

      <ul className="picker-list">
        {campaigns.map((c) => (
          <li key={c.id}>
            <button className="picker-card" onClick={() => navigate(`/c/${c.slug}/campaign`)}>
              <span className="picker-card-emoji">{c.logoEmoji || '🧭'}</span>
              <span className="picker-card-text">
                <span className="picker-card-name">{c.name}</span>
                {c.subtitle && <span className="picker-card-subtitle">{c.subtitle}</span>}
              </span>
              <span className="picker-card-role">
                {c.membershipRole === 'dm' ? 'DM' : c.membershipRole === 'player' ? 'Player' : 'Site Admin'}
              </span>
            </button>
          </li>
        ))}
      </ul>

      <footer className="picker-footer">
        <button className="picker-link" onClick={() => navigate('/settings')}>Account settings</button>
        {isAdmin && <span className="picker-hint">Site admin — create campaigns from Settings</span>}
      </footer>
    </div>
  )
}

export default CampaignPickerPage
